class FacetPicker extends HTMLElement {
    constructor() {
        super();

        this.debouncedOnSubmit = debounce(this.onSubmitHandler.bind(this), 800);

        this.form = this.querySelector('form');
        if (this.form) this.form.addEventListener('input', this.debouncedOnSubmit);

        this.addEventListeners();
    }

    connectedCallback() {
        this.initializeStepFromURL();
    }

    static setListeners() {
        window.addEventListener('popstate', (event) => {
            const searchParams = event.state ? event.state.searchParams : FacetPicker.searchParamsInitial;
            if (searchParams !== FacetPicker.searchParamsPrev) {
                FacetPicker.renderPage(searchParams, null, false);
            }
        });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
        FacetPicker.searchParamsPrev = searchParams;

        FacetPicker.getSections().forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            const filterDataUrl = (element) => element.url === url;

            FacetPicker.filterData.some(filterDataUrl)
                ? FacetPicker.renderSectionFromCache(filterDataUrl, event)
                : FacetPicker.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) FacetPicker.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url, event) {
        fetch(url)
            .then((response) => response.text())
            .then((html) => {
                FacetPicker.filterData.push({ html, url });
                FacetPicker.renderFilters(html, event);
            });
    }

    static renderSectionFromCache(filterDataUrl, event) {
        const html = FacetPicker.filterData.find(filterDataUrl).html;
        FacetPicker.renderFilters(html, event);
    }

    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const facetDetailsElementsFromFetch = Array.from(parsedHTML.querySelectorAll('picker-step'));

        // Identify the current step based on the event target, if any
        const currentStep = event?.target.closest('picker-step');

        // Find the next step to update
        const nextStepInDom = currentStep ? currentStep.nextElementSibling : null;

        if (nextStepInDom && nextStepInDom.tagName.toLowerCase() === 'picker-step') {
            const nextStepId = nextStepInDom.id;
            const nextStepFromFetch = facetDetailsElementsFromFetch.find(element => element.id === nextStepId);

            if (nextStepFromFetch) {
                // Update the next step with the new content
                nextStepInDom.innerHTML = nextStepFromFetch.innerHTML;
                // Show the next step after it has been rendered
                nextStepInDom.removeAttribute('hidden');
                currentStep.setAttribute('hidden', '');
            }
        }
    }

    static updateURLHash(searchParams) {
        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams ? `?${searchParams}` : ''}`);
    }

    static getSections() {
        const productPicker = document.getElementById('product-picker');
        return productPicker ? [{ section: productPicker.dataset.id }] : [];
    }

    createSearchParams(form) {
        const formData = new FormData(form);
        return new URLSearchParams(formData).toString();
    }

    allFieldsetsHaveSelectedInputs() {
        const fieldsets = this.querySelectorAll('fieldset');
        return Array.from(fieldsets).every((fieldset) => {
            const selectedInput = fieldset.querySelector('input:checked');
            return !!selectedInput;
        });
    }

    removeViewParameter() {
        // Clear the hidden input field with name 'view'
        const viewInput = this.querySelector('input[name="view"]');
        if (viewInput) {
            viewInput.value = ''; // Clear the hidden input field
        }
    }

    onSubmitForm(searchParams, event) {
        FacetPicker.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
        console.log(this.allFieldsetsHaveSelectedInputs());
        if (this.allFieldsetsHaveSelectedInputs()) {
            this.removeViewParameter(); // Clear the 'view' parameter before native submission
            this.querySelector('form').submit(); // Native form submission
        } else {
            event.preventDefault(); // Prevent native form submission
            const searchParams = this.createSearchParams(this.querySelector('form'));
            this.onSubmitForm(searchParams, event);
        }
    }

    addEventListeners() {
        const form = this.querySelector('form');

        form.addEventListener('change', (event) => {
            if (event.target.matches('input[type="radio"]')) {
                this.renderNextStep(event);
            }
        });

        form.addEventListener('click', (event) => {
            if (event.target.matches('[data-next]')) {
                event.preventDefault();
                this.renderNextStep(event);
            }
        });
    }

    renderNextStep(event) {
        const currentStep = event?.target.closest('picker-step');
        const nextStepInDom = currentStep ? currentStep.nextElementSibling : null;
        if (nextStepInDom) {
            this.querySelector('input[name="step"]').value = nextStepInDom.dataset.step;
            const searchParams = this.createSearchParams(this.querySelector('form'));
            FacetPicker.renderPage(searchParams, event, true);
        }
    }

    initializeStepFromURL() {
        const urlParams = new URLSearchParams(window.location.search);
        const step = urlParams.get('step');

        if (step) {
            const steps = Array.from(this.querySelectorAll('picker-step'));
            steps.forEach((pickerStep) => {
                if (pickerStep.dataset.step === step) {
                    pickerStep.removeAttribute('hidden');
                } else {
                    pickerStep.setAttribute('hidden', '');
                }
            });
        } else {
            // Show the first step if no step is specified
            const firstStep = this.querySelector('picker-step');
            if (firstStep) firstStep.removeAttribute('hidden');
        }
    }
}

FacetPicker.filterData = [];
FacetPicker.searchParamsInitial = window.location.search.slice(1);
FacetPicker.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-picker', FacetPicker);
FacetPicker.setListeners();